module.exports = "/_next/static/images/engineering-b4d76d0d9c935d0d8382a81a090eaa7b.webp";